import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {RightArrow} from "../../../icons/arrows/right-arrow";
import {LeftArrow} from "../../../icons/arrows/left-arrow";
import styles from "../styles/triple-3d-carousel.module.scss";
import classNames from "classnames";

class Triple3dCarouselBackwardArrowProps extends BaseProps {
  className: String;
  isRtl: Boolean;
  onClickPrev: Function;
}

  export const Triple3dCarouselBackwardArrow = ((props: Triple3dCarouselBackwardArrowProps) => {
  const backwardContainer = {
    className: classNames(styles.arrow_container),
    onClick: () => props.onClickPrev()
  };

  return (
    <div {...backwardContainer}>
      {
        props.isRtl ? <RightArrow className={props.className}/> : <LeftArrow className={props.className}/>
      }
    </div>
  )
});